import React, {Component} from 'react';
import {connect} from 'react-redux';
import _ from 'lodash';
import {Button} from 'semantic-ui-react';
import {formValueSelector} from 'redux-form';
import {PANES_INDICES} from '../../../common/dictionaries/binningInvoicing';
import {INVOICING_FORM} from '../../../common/forms';
import {Actions} from '../../../common/actions';
import Confirmation from './modal/confirmation';

class InvoicingFiltersButtons extends Component {
  constructor(props) {
    super(props);
    this.onSearchClick = this.onSearchClick.bind(this);
  }

  onSearchClick() {
    const {updateShowDataState, clientSelected, warehouseSelected} = this.props;
    updateShowDataState(true);
    const client = clientSelected;
    const warehouse = warehouseSelected;
    const withDetail = true;
    this.props.fetchInternalsOrdersList({client, warehouse}, withDetail);
  }

  renderSearchButton() {
    const {
      loadingClients,
      loadingWarehouses,
      loadingInternalsOrders,
      invoicing,
      activeTabIndex,
      clientSelected,
      warehouseSelected,
    } = this.props;
    if (activeTabIndex === PANES_INDICES.MANUAL_INVOICING) {
      return null;
    }

    return (
      <Button
        type='button'
        primary
        className='toyota-primary'
        disabled={!clientSelected || !warehouseSelected || loadingInternalsOrders || invoicing}
        loading={loadingClients || loadingWarehouses}
        onClick={this.onSearchClick}
      >
        Buscar
      </Button>
    );
  }

  renderInvoiceButton() {
    const {
      loadingClients,
      loadingWarehouses,
      loadingInternalsOrders,
      deleting,
      items,
      internalsOrdersList,
      savingLineInfo,
      checkIsInvoiceSaved,
      activeTabIndex,
      clientSelected,
      warehouseSelected,
      agencySelected,
      priceEditionReason,
    } = this.props;
    const isLoading = loadingClients || loadingWarehouses;
    const isInternalsOrdersTab = activeTabIndex === PANES_INDICES.INTERNALS_ORDERS_INVOICING;
    const filtersAreEmpty = !clientSelected || !warehouseSelected;
    const areItemsSavedInManualOrders = _.find(items, {'itemSaved': true});
    const ordersChecked = _.filter(internalsOrdersList, {'checked': true});
    
    const isDisabled = isInternalsOrdersTab ?
      filtersAreEmpty || savingLineInfo || !ordersChecked.length || loadingInternalsOrders :
      filtersAreEmpty || savingLineInfo || deleting || !areItemsSavedInManualOrders;

    return (
      <Confirmation items={items} disabled={isDisabled} loading={isLoading} isInternalsOrdersTab={isInternalsOrdersTab}
        client={clientSelected} warehouse={warehouseSelected} agency={agencySelected}
        checkIsInvoiceSaved={checkIsInvoiceSaved} priceEditionReason={priceEditionReason}/>
    );
  }

  render() {
    return (
      <>
        {this.renderSearchButton()}
        {this.renderInvoiceButton()}
      </>
    );
  }
}

const mapStateToProps = (state) => {
  const formValues = formValueSelector(INVOICING_FORM.name);
  const items = formValues(state, 'items');

  return {
    items,
    'deleting': state.invoicing.deleting,
    'invoicing': state.invoicing.invoicing,
    'loadingClients': state.dealer.loading,
    'clients': state.dealer.list,
    'loadingWarehouses': state.warehouses.loading,
    'warehouses': state.warehouses.list,
    'loadingInternalsOrders': state.internalOrder.loading,
    'internalsOrdersList': state.internalOrder.internalsOrdersList,
    'savingLineInfo': state.invoicing.savingLineInfo,
  };
};

const {
  fetchInternalsOrdersList,
} = Actions;

export default connect(mapStateToProps, {
  fetchInternalsOrdersList,
})(InvoicingFiltersButtons);
